<template>
    <div class="section_casts grid-container">
        <div class="grid-x grid-padding-x align-center">
            <section class="cell small-12 medium-10">
                <h2 class="section--title text-center"><strong>Casts</strong></h2>

                <ul class="grid-x grid-padding-x">
                    <li class="cell small-12" v-for="cast in mainCasts" :key="cast.id">
                        <article class="cast_article grid-x grid-padding-x">
                            <section class="cell small-12 medium-6">
                                <h3 class="cast_article--title" v-html="cast.name"></h3>
                                <figure class="cast_article--image hide-for-medium">
                                    <img :src="cast.image" :alt="cast.nameKanji">
                                </figure>
                                <p class="cast_article--content" v-html="cast.description"></p>
                            </section>
                            <figure class="cast_article--image cell small-12 medium-6 show-for-medium">
                                <img :src="cast.image" :alt="cast.nameKanji">
                            </figure>

                            <section class="comment_article">
                                <h3 class="comment_article--title"><img src="/netemosametemo/static/img/comment.png" alt="Comment"><strong class="seo">Comment</strong></h3>
                                <p class="comment_article--content" v-html="cast.comment"></p>
                            </section>
                        </article>
                    </li>
                </ul>

                <ul class="grid-x grid-padding-x">
                    <li class="cell small-6 large-4" v-for="cast in casts" :key="cast.id">
                        <cast-item :cast="cast" v-on:showModal="showModal"></cast-item>
                    </li>
                </ul>
            </section>
        </div>

        <modal-info :isActive="isActiveModal" v-on:closeModal="closeModal" :item="currentItem" :isCast="true"></modal-info>
    </div>
</template>

<script>
import Vue from 'vue'
import CastsItem from '@/components/CastsItem'
import ModalInfo from '@/components/ModalInfo'

Vue.component('cast-item', CastsItem)
Vue.component('modal-info', ModalInfo)
export default {
    name: 'casts',
    data () {
        return {
            isActiveModal: false,
            currentItem: {
                nameKanji: '',
                name: '',
                description: '',
                comment: '',
                image: ''
            },
            mainCasts: [
                {
                    nameKanji: '丸子亮平／鳥居麦：東出昌大',
                    name: 'MASAHIRO HIGASHIDE<strong>丸子亮平／鳥居麦：東出昌大</strong><small>（ひがしで・まさひろ）</small>',
                    description: '1988年2月1日、埼玉県生まれ。<br>『桐島、部活やめるってよ』（12/吉田大八監督）で俳優デビューし、第36回日本アカデミー賞新人俳優賞、第67回毎日映画コンクールスポニチグランプリ新人賞を受賞、鮮烈な印象を残す。主な映画出演作に、『クローズEXPLODE』（14/豊田利晃監督）、『アオハライド』（14/三木孝浩監督）、『GONIN サーガ』（15/石井隆監督）、『デスノート Light up the NEW world』（16/佐藤信介監督）、『聖の青春』（16/森義隆監督）、『予兆 散歩する侵略者 劇場版』（17/黒沢清監督）など。18年は本作の他、『OVER DRIVE』（羽住英一郎 監督）、『パンク侍、斬られて候』（石井岳龍監督）、『菊とギロチン』（瀬々敬久監督）、『ピース・ニッポン』（中野裕之監督/ナレーション）が現在公開中。今後も『ビブリア古書堂の事件手帖』（三島有紀子監督）が公開されるなど、本年６本もの出演作が公開される。連続テレビ小説「ごちそうさん」（13/NHK）でお茶の間でも人気を博し、「大河ファンタジー 精霊の守り人」（16~17/NHK）、「あなたのことはそれほど」（17/TBS）、「コンフィデンスマンJP」（18/CX）など、テレビドラマでも活躍中。11月には三島由紀夫原作の舞台化「豊饒の海」への主演が決定している。',
                    comment: '観た後に、胸に残るこの「疼き」は何なのか、未だに分かりません。<br>オファーを頂いた時は一人二役と聞き、キャラクターの差異をどのようにつけようかなどと夢想していましたが、監督のメソッドに真剣に取り組むうちに、浅はかな演じ分けなど必要ないと痛感しました。<br>クランクイン前のワークショップが多く、初めて耳にする演技法に則って現場に臨む日々でしたが、思い返してみると変わった事をやっていたのではなく、人ならば誰しも奥底に持っている真心を撮る為に、熱狂しながら撮影の日々を過ごしていたんだと思います。',
                    image: '/netemosametemo/static/img/casts/cast_01.jpg'
                },
                {
                    nameKanji: '泉谷朝子：唐田えりか',
                    name: 'ERIKA KARATA<strong>泉谷朝子：唐田えりか</strong><small>（からた・えりか）</small>',
                    description: '1997年9月19日、千葉県生まれ。<br>2014年、アルバイト先のマザー牧場でスカウトされ芸能界入り。15年に大手企業CMに抜擢され、一躍話題に。16年にはback number「ハッピーエンド」のMVに出演し、圧倒的な透明感で話題になる。テレビドラマでは「こえ恋」（16/TX）、「ブランケット・キャッツ」（17/NHK）、「トドメの接吻」（18/NTV）などに出演。ファッション誌「MORE」の専属モデルとしても活躍中。17年からは、韓国にも活躍の場を広げ、大手企業のCMやBrown Eyed Soulのナオルのシングル「Emptiness in Memory」MVなどに出演し、さらなる注目を集めている。本作『寝ても覚めても』で初ヒロインを務め、本格的に映画デビューを果たす。18年は本作の他、『ラブ×ドック』（鈴木おさむ監督）、ヒロインを務める『覚悟はいいかそこの女子。』（井口昇監督）が公開。今後も待機作が控えており、ますます活躍が期待される若手女優である。',
                    comment: '初のヒロイン、本格演技デビュー作ということもあり、初めは不安もあったのですが、東出さんがご飯に連れて行ってくださったり、敬語はやめようと言って頂いたお陰で、撮影前に関係性が作れたので、不安は無く、撮影に入るのが楽しみで仕方なかったです。なので、私は現場で無の状態で居られて、そのとき感じたものに嘘なく反応できました。後悔はないです<br>濱口監督は、お芝居に対して前向きになれなかった私を、前向きにさせてくれました。そして、お芝居の基盤を教わりました。<br>完成した作品を見て、知らない自分だらけで、嬉しくも怖くもなりましたが、この作品は目を逸らさずに全部優しく抱き締めてくれているようなそんな気がしました。<br>朝子のことをみんなに理解してもらえなくてもいい。でも一人一人に、何かが、届いてほしいです。「寝ても覚めても」、皆さんに出会えたことが私の財産です。<br>10代最後の夏、大恋愛しました！！！',
                    image: '/netemosametemo/static/img/casts/cast_02.jpg'
                }
            ],
            casts: [
                {
                    nameKanji: '串橋耕介：瀬戸康史',
                    name: 'KOJI SETO<strong>串橋耕介：瀬戸康史</strong><small>（せと・こうじ）</small>',
                    description: '1988年5月18日、福岡県生まれ。<br>2005年俳優デビュー。 ドラマや舞台、映画と幅広く活躍している。 近年の出演作品に、ドラマでは連続テレビ小説「あさが来た」（16/NHK）、「幕末グルメ ブシメシ！2」（18/NHK）、「海月姫」（18/CX）などがあり、「海月姫」ではその女装姿が大きな話題を集めた。舞台では「遠野物語・奇ッ怪其ノ参」（16/前川知大演出）、「陥没」（17/ケラリーノ・サンドロヴィッチ演出）などに出演し、昨年上演された舞台「関数ドミノ」（17/寺十吾演出）では第72回文化庁芸術祭演劇部門新人賞を受賞。映画では主演を務めた『合葬』（15/小林達夫監督）や『ミックス。』（17/石川淳一監督）、などに出演。18年は7月から放送開始するNHKドラマ10「透明なゆりかご」で、産婦人科医の由比役を演じる。',
                    comment: 'この作品は見てくださった方のその時の心境や、これまでの経験で受け止め方が大きく違ってくると思います。監督の演出も余計なものは削っていく方法ではじめての経験でした。主人公2人が行動していく様は本能的で、その純粋さが怖かった。人種や性別などは違っても僕らは“寝ても覚めても人間”なのだと感じました。',
                    image: '/netemosametemo/static/img/casts/seto_img.jpg'
                },
                {
                    nameKanji: '鈴木マヤ：山下リオ',
                    name: 'RIO YAMASHITA<strong>鈴木マヤ：山下リオ</strong><small>（やました・りお）</small>',
                    description: '1992年10月10日、徳島県生まれ。<br>2007年、「三井のリハウス」12代目リハウスガールに抜擢されデビューし脚光を浴びる。CMや雑誌モデルの他、数多くのドラマ、映画に出演。「A-Stuidio」（14-15/TBS）ではレギュラーでアシスタントを務めるなどバラエティでも活躍。主な映画出演作に『書道ガールズ!! わたしたちの甲子園』（10/猪股隆一監督）、『ほしのふるまち』（11/川野浩司監督）、『シャニダールの花』（13/石井岳龍監督）、『ナミヤ雑貨店の奇蹟』（17/廣木隆一監督）、『伊藤くん A to E』（18/廣木隆一監督）など。',
                    comment: '恋をすると、心が締め付けられ苦しくなる。それと同時に些細な事で幸せを感じ、なんとも言えない幸福の浮遊感を味わう。作品を見終わった後、そんな両極の感情がブワッと心に入ってきて、足枷はあるけど地上から浮いてるような不思議な感覚に包まれました。そして、たしかに私たちはあの時間を、作品の中で生きていた、と実感しました。そんな事を心から思えるのは、濱口監督、全てのスタッフ・キャストの皆さんのおかげです。是非、たくさんの方に観て頂きたいです。',
                    image: '/netemosametemo/static/img/casts/yamashita_img.jpg'
                },
                {
                    nameKanji: '島 春代：伊藤沙莉',
                    name: 'SAIRI ITO<strong>島 春代：伊藤沙莉</strong><small>（いとう・さいり）</small>',
                    description: '1994年5月4日、千葉県生まれ。<br>2003年より、子役として様々な作品に出演。近年では「TRANSIT GIRLS」（15/CX）、『全員、片想い/MY NICKNAME is BUTATCHI』（16/飯塚健監督）、『獣道』（17/内田英治監督）で主演を務めた。その他の主な出演作に、映画『blank13』（18/齊藤工監督）、『パンとバスと2度目のハツコイ』（18/今泉力哉監督）、『榎田貿易堂」（18/飯塚健監督）、舞台では「すべての四月のために」（17/鄭義信演出）など、ドラマでは連続テレビ小説「ひよっこ」（17/NHK）、「いつまでも白い羽根」（18/CX）、7月より放送開始する「この世界の片隅に」（TBS）がある。',
                    comment: '人が理性を失って、衝動的に行動を起こすのをハラハラしてみているつもりがワクワクして見守っていました。自分の中に否定的な何かよりむしろ説明のつかない高揚感が生まれているのに気付いてなんともいえない不思議な感覚に陥りました。それは初めて濱口監督の演出を受けた時の感覚と、とてもよく似ていました。そういう感覚とか、また違う感覚とか、しっかりスクリーンで感じていただきたいです。',
                    image: '/netemosametemo/static/img/casts/ito_img.jpg'
                },
                {
                    nameKanji: '岡崎伸行：渡辺大知',
                    name: 'DAICHI WATANABE<strong>岡崎伸行：渡辺大知</strong><small>（わたなべ・だいち）</small>',
                    description: '1990年8月8日、兵庫県生まれ。<br>2007年に地元神戸にて結成したロックバンド「黒猫チェルシー」のボーカルとして活躍中。演技未経験で主演に抜擢された映画『色即ぜねれいしょん』（09/田口トモロヲ監督）で、日本アカデミー賞新人俳優賞を受賞。15年には、「男子！レッツラゴン」（細川徹演出）で初舞台にして初主演、『モーターズ』で映画監督としてもデビューした。近年の主な出演作に、ドラマでは連続テレビ小説「まれ」（15/NHK）、「火花」（16/Netflix・NHK）、「毒島ゆり子のせきらら日記」（16/TBS）、映画は『勝手にふるえてろ』（17/大久明子監督）など。18年は『ギャングース』（18/入江悠監督）の公開が秋に控えている。\n',
                    comment: '濱口さんの現場は毎日が新鮮でした。ただ、なにか特異なことをしている訳でもなく、難しい課題があったわけでもないのですが、当たり前のことがとても新鮮に感じられました。『寝ても覚めても』は恋愛についての映画ではありますが、ひととひととの繋がりを描いた作品でもあります。ぼくもこの映画に出てくる素敵な登場人物たちとの大切な出会いの一片になれればと思ってやりました。素晴らしいスタッフ、キャストの方々と一緒にこの映画に参加できたことを光栄に思います。ぜひ楽しんでください！',
                    image: '/netemosametemo/static/img/casts/watanabe_img.jpg'
                },
                {
                    nameKanji: '平川：仲本工事',
                    name: 'KOJI NAKAMOTO<strong>平川：仲本工事</strong><small>（なかもと・こうじ）</small>',
                    description: '1941年7月5日、東京都生まれ。<br>1965年、いかりや長介をリーダーとしたコミックバンド「ザ・ドリフターズ」に加入。69年にスタートした「8時だヨ！全員集合」（TBS）は、最高視聴率50.5%の高視聴率を誇る長寿番組となる。その後、加藤茶、高木ブーと「こぶ茶バンド」を結成し、全国でライブ活動を行う。映画『YAWARA!』（89/吉田一夫監督）をはじめ、舞台、ドラマ、CMに多数出演。本作は17年ぶりの映画出演。',
                    comment: '別れても同じような人を選んでしまう。それが姿形、声まで同じだったら、あなたならどうします？ きっとすぐに受け入れてしまうのではないか。この映画のヒロインはそんな人。彼女には自分の道を見つけてほしい。 自分ひとりじゃ幸せになれない。 観る価値のある映画だと思いました。',
                    image: '/netemosametemo/static/img/casts/nakamoto_img.jpg'
                },
                {
                    nameKanji: '岡崎栄子：田中美佐子',
                    name: 'MISAKO TANAKA<strong>岡崎栄子：田中美佐子</strong><small>（たなか・みさこ）</small>',
                    description: '1959年11月11日、島根県生まれ。<br>1981年、ドラマ「思い出作り」（TBS）でデビュー。映画初出演にして初主演の映画『ダイヤモンドは傷つかない』（82/藤田敏八監督）で、日本アカデミー賞新人俳優賞を受賞する。その後も映画、ドラマ、舞台などで活躍。主な映画出演作に『彼女が水着にきがえたら』（89/馬場康夫監督）、『べっぴんの町』（89/原隆仁監督）、『遥かなる甲子園』（90/大澤豊監督）、『とられてたまるか!?』（94/萩庭貞明監督）など。近年の主な出演作に、『彼らが本気で編むときは、』（17/荻上直子監督）、『ミックス。』（17/石川淳一監督）。',
                    comment: '脚本はすごく静かな印象でした。監督の演出は初めての経験だらけで驚きの連続でしたが、まっさらな心を撮りたいという監督の狙い通りに、東出さんも唐田さんももすごくきれいな心で臨んでいるのを感じました。私が演じた栄子はちょっと怖い感じの人かと思っていましたが、実際に演じた栄子は違いました。母は母ですね。この作品が、濱口監督の色になることが楽しみです。',
                    image: '/netemosametemo/static/img/casts/tanaka_img.jpg'
                }
            ]
        }
    },

    methods: {
        showModal (item) {
            this.currentItem = item
            this.isActiveModal = true
        },
        closeModal () {
            this.isActiveModal = false
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Casts.vue